import React from 'react';
import clsx from 'clsx';
import { Form, InputField } from '@is24at/react-ui-core/Form';
import { FlexBox } from '@is24at/react-ui-core';
import { SearchParamsEnum } from 'utils/enums';
import GeoAutoComplete from '../components/GeoAutoComplete';
import SortFilterContainer from '../../SortFilterContainer/SortFilterContainer';
import styles from './SearchRibbonForm.scss';

interface SearchRibbonFormProps {
  handleSubmit(...args: unknown[]): unknown;
  isLoading?: boolean;
  headline?: string;
  totalHits: number;
  initialValues?: any;
}

const SearchRibbonForm = ({
  handleSubmit,
  isLoading = false,
  headline = 'Maklersuche',
  totalHits,
  initialValues,
}: SearchRibbonFormProps) => {
  return (
    <section className={styles.stage}>
      <h1 className={styles.headline}>{headline}</h1>
      <Form
        onSubmit={handleSubmit}
        formSettings={{ defaultValues: initialValues }}
        formProps={{ className: clsx(styles.search__form, styles.search) }}
      >
        <FlexBox
          className={clsx(styles.search__form__controls, 'pb-16', 'pt-16')}
          alignItems="normal"
          direction="column"
          spacing={0}
        >
          <div
            className={clsx(
              styles.search__form__input,
              styles['search__form__input--gac-widget'],
            )}
          >
            <GeoAutoComplete
              className={styles.search__form__input__gacwidget}
            />
          </div>

          <InputField
            fieldProps={{
              type: 'text',
              placeholder: 'Name des Maklers',
              name: SearchParamsEnum.companyName,
              className: styles['search__form__input__company-name'],
              'data-testid': SearchParamsEnum.companyName,
            }}
            containerProps={{
              className: clsx(
                styles.search__form__input,
                styles['search__form__input--company-name'],
              ),
            }}
          />

          <div
            className={clsx(
              styles.search__form__input,
              styles['search__form__input--submit'],
            )}
          >
            <input
              type="submit"
              disabled={isLoading}
              value="Makler finden"
              className={styles.search__form__input__submit}
            />
          </div>
        </FlexBox>
        <FlexBox justifyContent="space-between">
          <span>{totalHits} Makler gefunden</span>
          <SortFilterContainer />
        </FlexBox>
      </Form>
    </section>
  );
};

export default SearchRibbonForm;
